import React from 'react';

const Services = () => {
    return (
        <section id="services" className="services-area services-eight">
            <div className="section-title-five">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="content">
                                <h6>Nos services</h6>
                                <h2 className="fw-bold">Tarifs compétitifs à partir de 50$</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-user"></i>
                            </div>
                            <div className="service-content">
                                <h4>Déclarations de particuliers salariés</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-island"></i>
                            </div>
                            <div className="service-content">
                                <h4>Déclarations de personnes retraités</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-apartment"></i>
                            </div>
                            <div className="service-content">
                                <h4>Déclarations de revenu locatif</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-car-alt"></i>
                            </div>
                            <div className="service-content">
                                <h4>Déclarations de travailleurs autonome, uber etc</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-graduation"></i>
                            </div>
                            <div className="service-content">
                                <h4>Déclarations pour étudiants</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-briefcase"></i>
                            </div>
                            <div className="service-content">
                                <h4>Déclarations pour nouveaux arrivants, non résidents et
                                    demandeurs d'asile</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-services">
                            <div className="service-icon">
                                <i className="lni lni-revenue"></i>
                            </div>
                            <div className="service-content">
                                <h4> Déclaration de revenu de placement</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;